import { safeParse } from "valibot";
import { type Upload, UploadSchema } from "../schema";

export function getUploadEventName() {
  return "upload-status-changed";
}

export function onUploadStatusChange(upload: Upload) {
  const result = safeParse(UploadSchema, upload);

  if (!result.success) {
    throw new Error(JSON.stringify(result.issues));
  }

  const eventName = getUploadEventName();
  const event = new CustomEvent(eventName, { detail: result.output });
  document.dispatchEvent(event);
}
